module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(!this.active) ? _c('accident-report-submitted', {
    attrs: {
      "accident": _vm.accidentObj
    }
  }) : (this.active) ? _c('div', {
    staticClass: "content-wrapper"
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "can-cancel": true,
      "on-cancel": _vm.onCancel,
      "is-full-page": _vm.fullPage
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "titleDiv"
  }, [_c('h2', [_c('strong', [_vm._v("Accident Report Form")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("This form will help us get "), _c('strong', [_vm._v("pertinent")]), _vm._v(" information about your auto accident to best assist in making this process as easy and rewarding as possible for you.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please fill out this form to the best of your knowledge. One of our Accident Support Specialists will recieve this report and assist you towards your accident claims goals! ")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Type of Accident")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Please select the type of accident you were in:")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select type of accident"
    },
    model: {
      value: (_vm.accidentTypeSelect),
      callback: function($$v) {
        _vm.accidentTypeSelect = $$v
      },
      expression: "accidentTypeSelect"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Date and Time of Accident")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Please select the date and time of the accident.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "example-datepicker"
    }
  }, [_vm._v("Date of accident:"), _c('span', {
    staticStyle: {
      "content": "'*'",
      "color": "red"
    }
  }, [_vm._v(" * ")])]), _vm._v(" "), _c('date-picker', {
    staticClass: "mb-2",
    attrs: {
      "id": "example-datepicker"
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "example-timepicker"
    }
  }, [_vm._v("Time of accident: ")]), _vm._v(" "), _c('time-picker', {
    attrs: {
      "format": "hh:mm A",
      "locale": "en"
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Location of Accident")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Please Enter Address of Accident")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "Please input Address"
    },
    model: {
      value: (_vm.accidentLocation),
      callback: function($$v) {
        _vm.accidentLocation = $$v
      },
      expression: "accidentLocation"
    }
  }), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Vehicle Speed")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Speed of vehicle"), _c('strong', [_vm._v("(in MPH)")]), _vm._v(" at time of Impact?(Don't worry, it doesn't have to be exact)")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-slider', {
    attrs: {
      "show-input": ""
    },
    model: {
      value: (_vm.vehicleSpeedValue),
      callback: function($$v) {
        _vm.vehicleSpeedValue = $$v
      },
      expression: "vehicleSpeedValue"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Upload Media")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Things that you feel are pertinent to the current accident(impact images, recorded conversations, license plate numbers, etc.)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "list-type": "picture",
      "auto-upload": false,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUpload,
      "limit": 10,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList,
      "multiple": true,
      "on-preview": _vm.handlePreview,
      "on-success": _vm.handleSuccess,
      "http-request": _vm.uploadFiles,
      "on-error": _vm.handleError,
      "on-change": _vm.handleChange
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Media files with a size less than 10Mb(limit of 10 files)")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": _vm.fileNameSelected
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Vehicle Make and Model")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Please select the Make and Model of your Vehicle:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Make")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Make"
    },
    on: {
      "change": function($event) {
        return _vm.updateModelDropdown()
      }
    },
    model: {
      value: (_vm.makeValue),
      callback: function($$v) {
        _vm.makeValue = $$v
      },
      expression: "makeValue"
    }
  }, _vm._l((this.makeOptions), function(item) {
    return _c('el-option', {
      key: item.brand,
      attrs: {
        "label": item.brand,
        "value": item.brand
      }
    })
  }), 1), _vm._v(" "), _c('h4', [_vm._v("Model")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Model",
      "disabled": _vm.modelOptions.length === 0
    },
    model: {
      value: (_vm.modelValue),
      callback: function($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue"
    }
  }, _vm._l((this.modelOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('h4', [_vm._v("Year")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Year"
    },
    model: {
      value: (_vm.yearValue),
      callback: function($$v) {
        _vm.yearValue = $$v
      },
      expression: "yearValue"
    }
  }, _vm._l((_vm.yearOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Services Needed")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v("Please select the service(s) you would like to recieve for your accident:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "overflow": "auto"
    },
    model: {
      value: (_vm.servicesNeededCheckList),
      callback: function($$v) {
        _vm.servicesNeededCheckList = $$v
      },
      expression: "servicesNeededCheckList"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Have medical services assist you with your injuries.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Medical"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Towing"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Get legal assistance to help with your auto accident.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Legal"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Rent a vehicle to get around in the meanwhile.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Car Rental Service"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Look for a new vehicle.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Auto-Dealership"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_c('strong', [_vm._v("Additional Information")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Any Additional Information About the Accident you would like to note? This could be things like where you were when the other driver hit you, what the other car looked like, etc.")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Input additional details Here..."
    },
    model: {
      value: (_vm.additionalInfoTextArea),
      callback: function($$v) {
        _vm.additionalInfoTextArea = $$v
      },
      expression: "additionalInfoTextArea"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.submitReport
    }
  }, [_vm._v("Submit Accident Report")])])], 1)])]), _vm._v(" "), _c('br')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fd1cf0d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccidentInformationInput.vue
// module id = 1333
// module chunks = 2